module.exports = __webpack_public_path__ + "img/ondulacao.a4d90db7.svg";